
import AppBrowse from "@/components/browse/Browse.vue";
import { FrequencyDocument } from "@/models/base";
import { BrowseService } from "@/services/browse-service";
import { FrequencyDocumentService } from "@/services/frequency-document-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import Vue from "vue";
import { UserConfigService } from "../../services/user-config-service";
import { checkHasModule } from "../../router";
import { MODULE } from "../../config/modules";
import { ISelectItem } from "winfakt-vue-components/src/classes";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { View } from "@/models/view";
import { BrowseState } from "@/utils/browse/browse-state";


export default Vue.extend({
	data(){
		return {
			selectedItems: [] as FrequencyDocument[],
			browseState: null as null | BrowseState,
		};
	},
	props: {
		browseId: Number,
		controlsDisabled: Boolean,
		searchEnabled: Boolean
	},
	computed: {
		dataSource(): IBrowseDataSource<FrequencyDocument> {
			let elem = this;
			return {
				getFullElement: async(el:FrequencyDocument) =>FrequencyDocumentService.getDocument(el.ID),
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getElements: FrequencyDocumentService.getFrequencyDocuments.bind(FrequencyDocumentService),
				async getTotals(view:View):Promise<FetchedTotal[]> {
					return FrequencyDocumentService.getTotals(view);
				},
				edit(doc: FrequencyDocument) {
					elem.$router.push(`/subscriptions/edit/${doc.ID}`);
				},
				async delete(docs: FrequencyDocument[]) {
					await FrequencyDocumentService.deleteDocs(docs);
					return true;
				},
				addRoute: `/subscriptions/new`,
				browseName: "Subscriptions",
				modelName: "FrequencyDocument",
				browsePermissions: ()=>UserConfigService.getPermissionSettings().SubscriptionPermissions
			};
		},
		stopAction():ISelectItem<string>{
			return {
				text: this.$ct("stop-frequency-document").toString(),
				value: "stopFrequencyDocument",
				icon: "ban"
			};
		},
		buttonBarItems():ISelectItem<string>[] {
			let items:ISelectItem<string>[]= [
				{text: this.$ct("create-manual-frequency-documents").toString(), value: "createManualFrequencyDocuments", icon: "cog"}
			];
			if (this.selectedItems.length == 1) {
				items.push(this.stopAction);
			}
			return items;
		},
		contextMenuItems():ISelectItem<string>[] {
			return [
				{text: this.$ct("remove-mollie-mandate"), value: "removeMollieMandate", icon: "stop-circle"},
				this.stopAction
			];
		}
	},
	methods: {
		async createManualFrequencyDocuments() {
			await FrequencyDocumentService.createManualFrequencyDocuments();
		},
		async removeMollieMandate(doc:FrequencyDocument){
			if (doc.MollieMandateID == "") {
				this.$wf.dialog(this.$ct("this-document-does-not-have-automatic-payments"), this.$ct("common.Ok"), this.$ct("common.error"), "warning");
				return;
			};
			let d = await FrequencyDocumentService.getDocument(doc.ID);
			d.MollieMandateID = "";
			await FrequencyDocumentService.putDoc(d);
			doc.MollieMandateID = "";
			this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
		},
		updateView() {
			if (!this.browseState) return;
			this.browseState.fetch();
		},
		async stopFrequencyDocument(value?:FrequencyDocument) {
			if (!value) {
				if (this.selectedItems.length < 1) {
					return;
				}
				value = this.selectedItems[0];
			}
			let message = this.$ct("are-you-sure-that-you-want-to-stop-frequency-doc", {nr: value.ID});
			let confirm = await (this.$confirmBuilder(message).setWarningTitle().show());
			if (!confirm) return;

			let result = await FrequencyDocumentService.stopDocument(value);
			value.NextExecutionDate = result.NextExecutionDate;
			value.EndDate = result.EndDate;
		}
	},
	mounted() {
		ToolbarService.title = this.$ct("subscriptions");
	},
	created(){
		if (!checkHasModule(MODULE.ABONNEMENTEN, this.$router)){
			throw new Error("MISSING MODULE");
		}
	},
	components: {
		AppBrowse,
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
